// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3HaXj","title":"Images90_title__23J7P","images":"Images90_images__2DjKd"};